import React from "react"
import PropTypes from "prop-types"
import { Elements } from "@stripe/react-stripe-js"
import StripeProps from "components/PropTypes/StripeProps"

// If we don't specify a locale here, it Stripe will try
// to infer the locale automatically which can cause a mismatch
// between what the app is rendering and what Stripe is rendering.
//
// Thankfully our locale codes match what Stripe uses so we can
// just pass it in as is.
//
// https://docs.stripe.com/js/appendix/supported_locales
const options = {
  /* eslint-disable-next-line no-undef */
  locale: Config.i18n_locale || "auto",
}

const StripeProvider = ({ stripe = null, children }) => (
  <Elements stripe={stripe} options={options}>
    {children}
  </Elements>
)

StripeProvider.propTypes = {
  children: PropTypes.node.isRequired,
  stripe: PropTypes.oneOfType([StripeProps, PropTypes.instanceOf(Promise)]),
}

export default StripeProvider
